(() => {
  const productRecommendationsSection = document.querySelector(
    ".product-recommendations"
  );

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const { url } = productRecommendationsSection.dataset;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(".product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          productRecommendationsSection.style.height = "auto";
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .then(() => {
        // eslint-disable-next-line no-new, no-undef
        const swiper = new Swiper(".related-products__swiper", {
          slidesPerView: 2.2,
          spaceBetween: 15,
          breakpoints: {
            1024: {
              slidesPerView: 4,
              allowSlideNext: false,
              allowSlidePrev: false,
              allowTouchMove: false,
            },
          },
        });
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: "0px 0px 200px 0px",
  });

  observer.observe(productRecommendationsSection);
})();
